<template>
  <div style="height:100%">
    <router-view v-if="this.$route.path != '/StudentEvaluate'" />
    <div class="collect" v-else>
      <div class="headline">
        <p class="headline-name">
          <img class="messageico" src="../../assets/imgs/pingjiao.png" />
          <!-- <span class="messageico">评教</span> -->
          <span
            style="display: inline-block;position: absolute;font-size: 2.2vh;font-weight: 700;top: 4.08%;left: 4.5%;"
            >{{this.$t('translateText.StudentEvaluate.pj')}}</span
          >
        </p>
      </div> 
      <div class="nav-body">
        <test
          :columns="columns"
          :data2="data"
          :value="value"
          :Show="false"
          @through="viewEvaluation(arguments)"
        ></test>
      </div>
      <!-- <pag /> -->
      <pag ref="StudentEvaluate" @passpage="passpage" />
    </div>
  </div>
</template>
<script>
const moment = require('moment')
import test from '@/components/Table/Table'
import pag from '@/components/pagiation'
import { getEvaluationByUser } from '../../utils/api'

export default {
  data() {
    return {
      pageNumber: 1,
      bodyHeight: 0,
      data: [],
      value: [1, 2, 3],
    }
  },
  created() {
    this.userinfo = this.$store.state.userinfo
    this.GetEvaluation()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('translateText.StudentEvaluate.pjmc'),
          dataIndex: 'name',
          width: 340,
        },
        {
          title: this.$t('translateText.StudentEvaluate.plsj'),
          dataIndex: 'time',
          width: 165,
        },
        {
          title: this.$t('translateText.sw.cz'),
          dataIndex: 'iseval',
          scopedSlots: { customRender: 'eval' },
          width: 80,
        },
      ]
    },
  },
  mounted() {},
  methods: {
    passpage(pageNumber) {
      // this.current=pageNumber
      this.pageNumber = pageNumber
      this.GetEvaluation()
    },
    GetEvaluation() {
      getEvaluationByUser({
        iCurPage: this.pageNumber,
        iPageSize: 10,
        iUserId: this.userinfo.iUserId,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.loadData(response.data.objData.listPage)
          this.$refs.StudentEvaluate.showTotal =
            response.data.objData.iTotalPages * 10
          this.$refs.StudentEvaluate.pageNumber =
            response.data.objData.iPageIndex
          sessionStorage.setItem(
            'showTotal',
            response.data.objData.iTotalPages * 10
          )
          sessionStorage.setItem('pageNumber', response.data.objData.iPageIndex)
          // this.data = response.data.objData.listPage;
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    //加载数据
    loadData(data) {
      this.data = []
      for (let i = 0; i < data.length; i++) {
        let evaluation = {
          key: i,
          name: data[i].userCourse.course.strCourseName + this.$t('translateText.StudentEvaluate.kcpj'),
          time: moment(data[i].dtEvaluationTime).format('YYYY-MM-DD'),
          courseName: data[i].userCourse.course.strCourseName,
          // teacher:
          iseval: data[i].userCourse.ddEvaluationType.iNumber,
          userCourseId: data[i].userCourse.iUserCourseId,
          star: data[i].dEvaluationResultAvg,
        }
        this.data.push(evaluation)
      }
    },
    viewEvaluation(arg) {
      console.log(arg)
      let userCourseId = arg[0].userCourseId
      let iseval = arg[0].iseval
      this.$router.push(
        '/StudentEvaluate/EvaluateParticulars?userCourseId=' +
          userCourseId +
          '&iseval=' +
          iseval
      )
    },
  },
  components: {
    pag,
    test,
  },
}
</script>
<style lang="stylus" scoped>
.collect
  width: 100%;
  height: 100%;
  background-color: white;
  position relative
.headline {
  width: 90%;
  height: 10%;
  margin-left 2%
  border-bottom: 2px solid #dadada;
  @media (max-width: 1025px) {
    height: 12%;
  }

  @media (max-width: 500px) {
    height: 15%;
  }
}
.messageico {
    position absolute
    width: 1.6%;
    height: 2.8%;
    top: 3.8%;
    left: 2%;
}
.headline-name
  width: 30%;
  height: 50%;
  margin-left: 2%;
  font-size: 15px;
  letter-spacing: 2px;
  font-weight: 700;
  display: -webkit-flex;
  float:left
.nav-body
    margin-top 2%
    margin-left 2%
    width 90%
</style>
